import { CTA, designTokens } from '@volkswagen-onehub/components-core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as React from 'react';
import styled from 'styled-components';

gsap.registerPlugin(ScrollTrigger);

const WrapperSection = styled.div`
	/* Global CSS */
	--c-white: ${designTokens.global.white000};
	--c-black: ${designTokens.global.black100};
	--c-grey200: ${designTokens.global.grey200};
	--c-blue200: ${designTokens.global.blue200};
	--c-blue600: ${designTokens.global.blue600};
	--c-blue900: ${designTokens.global.blue900};

	/* Remove horizontal scroll from gallery */
	section[data-testid='gallery-overflow-x-hidden'] {
		& > div > div {
			overflow-x: hidden;
			touch-action: pan-y;
		}
	}
`;

export const GeneralWrapper = ({ children }: { children: React.ReactNode }): React.ReactElement => {
	return <WrapperSection className="general-wrapper-section">{children}</WrapperSection>;
};

type WhiteCTAProps = {
	margin?: string;
	marginTop?: number;
	marginBottom?: number;
	marginLeft?: number;
	marginRight?: number;
	contrast?: boolean;
};

export const WhiteCTA = styled(CTA)<WhiteCTAProps>`
	margin: ${(props) => props.margin || '0'};
	margin-top: ${(props) => props.marginTop || 0}px;
	margin-bottom: ${(props) => props.marginBottom || 0}px;
	margin-left: ${(props) => props.marginLeft || 0}px;
	margin-right: ${(props) => props.marginRight || 0}px;
	background-color: var(--c-white) !important;
	color: var(--c-blue600) !important;

	&:hover,
	&:active,
	&:focus {
		background-color: var(--c-blue200) !important;
		background-color: ${(props) => (props.contrast ? 'var(--c-blue900)' : 'var(--c-blue200)')} !important;
		color: ${(props) => (props.contrast ? 'var(--c-white)' : 'var(--c-blue600)')} !important;
	}

	&:focus:not(:hover) {
		background-color: var(--c-white) !important;
		color: var(--c-blue600) !important;
	}
`;
